import {Options} from '@fl/cmsch-fe-library';

import {OrganizationCenterAutocomplete} from 'api/gen/OrganizationCenterAutocomplete';

/**
 * Converts organization-center autocomplete rows into select options.
 *
 * @param elements Organization-center autocomplete rows returned by the API.
 * @returns Organization-center select options with code, name, and organization code.
 */
export const genCentersOptions = (elements: Array<OrganizationCenterAutocomplete>): Options<number> =>
    elements.map(option => ({
        value: option.id,
        label: option.organizationCenterCode
            .concat(option.organizationName ? ` - ${option.organizationName}` : '')
            .concat(option.organizationCode ? ` (${option.organizationCode})` : ''),
    }));
